(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sk-cart-hold"] && !Shopify.designMode) return;
  try {
    /* The cart is kept for N minutes from its first item, then really emptied. The deadline lives in this
     browser's storage, so reloads and other pages count to the same moment; without storage the time would
     restart on every page, so the pill stays hidden. The pill lives in the drawer only, so the cart page, which
     has no drawer, never empties the cart unseen. Checking out before zero goes ahead as usual. */
  (() => {
    if (window.skCartHold) return;
    window.skCartHold = true;

    const KEY = 'sk-cart-hold';
    const store = {
      get() {
        try {
          return Number(window.localStorage.getItem(KEY)) || 0;
        } catch (error) {
          return null;
        }
      },
      set(value) {
        try {
          window.localStorage.setItem(KEY, String(value));
          return true;
        } catch (error) {
          return false;
        }
      },
      clear() {
        try {
          window.localStorage.removeItem(KEY);
        } catch (error) {
          /* Nothing was stored. */
        }
      },
    };

    let expiring = false;

    const expire = async (message) => {
      expiring = true;
      store.clear();
      try {
        const dialog = document.getElementById('SkCartDrawer');
        const base = (dialog && dialog.dataset.cartUrl) || '/cart';
        const response = await fetch(`${base}/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        // sk.js re-renders the drawer and the cart count; without it a reload shows the empty cart.
        const cart = window.Satinknit && window.Satinknit.cart;
        if (!cart) {
          window.location.reload();
          return;
        }
        await cart.refresh();
        if (!message) return;
        document.querySelectorAll('[data-sk-cart-content] .sk-drawer__head').forEach((head) => {
          const note = document.createElement('p');
          note.className = 'sk-cart-hold';
          note.setAttribute('role', 'status');
          note.textContent = message;
          head.after(note);
        });
      } catch (error) {
        /* The cart stays as it was; the next page load tries again. */
      } finally {
        expiring = false;
      }
    };

    // The drawer is re-rendered after every cart change, so each second looks the pill up again.
    const tick = () => {
      if (expiring || document.querySelector('[data-sk-cart-page]')) return;
      const pills = document.querySelectorAll('[data-sk-hold]');
      if (pills.length === 0) {
        // An empty cart (or the timer turned off) ends the hold, so the next first item starts a fresh one.
        store.clear();
        return;
      }
      let deadline = store.get();
      if (deadline === 0) {
        deadline = Date.now() + Number(pills[0].dataset.skHold) * 60000;
        if (!store.set(deadline)) deadline = null;
      }
      if (deadline === null) {
        pills.forEach((pill) => {
          pill.hidden = true;
        });
        return;
      }
      const left = deadline - Date.now();
      if (left <= 0) {
        expire(pills[0].dataset.expiredText);
        return;
      }
      const total = Math.ceil(left / 1000);
      const time = `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
      pills.forEach((pill) => {
        const slot = pill.querySelector('[data-sk-hold-time]');
        if (slot && slot.textContent !== time) slot.textContent = time;
        pill.removeAttribute('data-sk-pending');
      });
    };

    const start = () => {
      tick();
      setInterval(tick, 1000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-delivery-timer"] && !Shopify.designMode) return;
  try {
    /* The time counts down to midnight in the shopper's time zone, then starts again for the next day. The date
     is today plus the processing days (business days; an order at a weekend starts on Monday) plus the transit
     days, in calendar or business days, all on the shopper's own calendar. */
  (() => {
    if (window.skDeliveryTimer) return;
    window.skDeliveryTimer = true;

    const isWeekday = (date) => date.getDay() % 6 !== 0;

    const addDays = (start, days, business) => {
      const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
      for (let left = days; left > 0; ) {
        date.setDate(date.getDate() + 1);
        if (!business || isWeekday(date)) left -= 1;
      }
      return date;
    };

    const arrival = (now, shipDays, transit, business) => {
      const ship = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      while (!isWeekday(ship)) ship.setDate(ship.getDate() + 1);
      return addDays(addDays(ship, shipDays, true), transit, business);
    };

    const dateLabel = (date) => {
      const options = { weekday: 'long', month: 'short', day: 'numeric' };
      try {
        return date.toLocaleDateString(document.documentElement.lang || undefined, options);
      } catch (error) {
        return date.toLocaleDateString(undefined, options);
      }
    };

    /* Time left to the shopper's next midnight: 05:12:09. It runs 23:59:59 down to 00:00:00, then starts again. */
    const clock = (now) => {
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const total = Math.max(0, Math.floor((midnight - now - 1) / 1000));
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(Math.floor(total / 3600))}:${pad(Math.floor(total / 60) % 60)}:${pad(total % 60)}`;
    };

    const setText = (element, text) => {
      if (element && element.textContent !== text) element.textContent = text;
    };

    const tick = () => {
      const now = new Date();
      document.querySelectorAll('[data-sk-cutoff]').forEach((line) => {
        const [shipDays, transit, count] = String(line.dataset.skCutoff).split(',').map((value, index) => (index < 2 ? Number(value) : value));
        if (!(shipDays >= 0) || !(transit >= 0)) return;
        setText(line.querySelector('[data-sk-cutoff-date]'), dateLabel(arrival(now, shipDays, transit, count !== 'calendar')));
        setText(line.querySelector('[data-sk-cutoff-time]'), clock(now));
        line.removeAttribute('data-sk-pending');
      });
    };

    // One clock for the page; a section reloaded in the theme editor is picked up on the next second.
    const start = () => {
      tick();
      setInterval(tick, 1000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-fit-guide"] && !Shopify.designMode) return;
  try {
    /* The link opens its popup; the close button, Escape and a click on the dimmed backdrop close it, and the
     browser returns focus to the link. In the theme editor, selecting the block shows the popup. */
  (() => {
    if (window.skFitGuide) return;
    window.skFitGuide = true;

    const open = (opener) => {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && !dialog.open) dialog.showModal();
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const opener = target.closest('[data-sk-fit-open]');
      if (opener) {
        open(opener);
        return;
      }
      const closer = target.closest('[data-sk-fit-close]');
      if (closer) {
        closer.closest('dialog').close();
        return;
      }
      // The panel fills the dialog, so a click landing on the dialog itself is on the backdrop.
      if (target instanceof HTMLDialogElement && target.classList.contains('sk-fit')) target.close();
    });

    document.addEventListener('shopify:block:select', (event) => {
      const opener = event.target instanceof Element && event.target.querySelector('[data-sk-fit-open]');
      if (opener) open(opener);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const opener = event.target instanceof Element && event.target.querySelector('[data-sk-fit-open]');
      const dialog = opener && document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && dialog.open) dialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-stock"] && !Shopify.designMode) return;
  try {
    /* The line follows the colour just picked: its swatch carries the count only while low, and other
     colours get the general text ("Limited stock available"), or no line while that text is blank. */
  (() => {
    if (window.skStockLine) return;
    window.skStockLine = true;

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-colour]')) return;
      const product = input.closest('[data-sk-product]');
      const line = product && product.querySelector('[data-sk-stock]');
      if (!line) return;
      const count = Number(input.dataset.lowStock) || 0;
      const template = count > 0 ? line.dataset.skStock : line.dataset.general || '';
      line.hidden = !template;
      const text = line.querySelector('[data-sk-stock-text]');
      if (!template || !text) return;
      const nodes = [];
      template
        .split('{colour}')
        .join(input.dataset.colour)
        .split('{count}')
        .forEach((part, index) => {
          if (index) {
            const strong = document.createElement('strong');
            strong.textContent = String(count);
            nodes.push(strong);
          }
          nodes.push(part);
        });
      text.replaceChildren(...nodes);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
